<template>

    <v-modal title="Create Project">
        <template #body>
            <v-alert :message="error" />
            <form @keydown.enter.prevent="createProject">
                <v-form-group dir="ver" label="Project Name">
                    <v-input placeholder="My Project Name" :model="params.name" @input="params.name = $event" />
                </v-form-group>
                <v-form-group dir="ver" label="Website">
                    <v-input placeholder="https://mysite.com" :model="params.website" @input="params.website = $event" />
                </v-form-group>
                <v-form-group dir="ver">
                    <v-checkbox label="Assign to all members" :model="params.assign_to_members" @input="params.assign_to_members = $event" />
                </v-form-group>
            </form>
        </template>
        <template #footer>
            <v-button size="sm" btn-style="white" @click.native="cancel">Cancel</v-button>
            <v-button size="sm" :loading="loading" @click.native="createProject">Create Project</v-button>
        </template>
    </v-modal>

</template>

<script>

import CompanyApi from '@api/CompanyApi';

export default {

    data() {
        return {
            loading: false,
            error: null,
            params: {
                assign_to_members: true,
            },
        }
    },

    methods: {

        createProject() {
            this.loading = true;
            CompanyApi.createProject(this.$store.getters.company.id, this.params)
                .then((response) => {
                    this.loading = false;
                    this.$emit('created', response.data.data);
                    this.$store.commit('showModal', false);
                }, (error) => {
                    this.loading = false;
                    this.error = error.response.data.message;
                });
        },

        cancel() {
            this.$store.commit('showModal', false);
        },

    }

}

</script>
